import { render, staticRenderFns } from "./LocalizationProjectForm.vue?vue&type=template&id=576c3ae6&"
import script from "./LocalizationProjectForm.vue?vue&type=script&lang=js&"
export * from "./LocalizationProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports